export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M5 19V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zm9-14h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z\"/>"
};